export default __webpack_public_path__ + "assets/images/73f85dfafb2e6816489085cfc1b996b6-warning.svg";